import { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import EntryAgreementGate from "@/components/EntryAgreementGate";
// import SummerSaleWidget from "@/components/SummerSaleWidget"; // HIDDEN: uncomment to restore summer sale popup

export default function SiteLayout() {
  const [entryAccepted, setEntryAccepted] = useState(false);

  return (
    <EntryAgreementGate onAccepted={() => setEntryAccepted(true)}>
      <div className="min-h-screen flex flex-col bg-white">
        <Navbar />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
      {/* {entryAccepted && <SummerSaleWidget />} */}
    </EntryAgreementGate>
  );
}
